import React from "react";

export default function PageNotFound() {
    return (
        <div className="PageNotFound">
            <h1 className="text-xl text-center my-40">Page Not Found</h1>
        </div>
    )
}
